document.addEventListener('DOMContentLoaded', function () {
  function addItemsToSet(item, set, attributeName) {
    const data = item.getAttribute(attributeName).split(',');
    data.forEach(item => {
      item = item.trim();
      if (item !== '') {
        set.add(item);
      }
    });
  }

  let timerId;
  let mobileNutrientTrackerElement = document.querySelector(
    '.cart-drawer__mobile-nutrient-tracker'
  );
  let isTimerActive = false;

  function updatenutrients() {
    console.log('updatenutrients called');
    const shippingNotifyElement = document.querySelector('.shipping-notify');

    if (shippingNotifyElement && shippingNotifyElement.classList.contains('active')) {
      return;
    }

    const getItems = document.querySelectorAll('.cart-item');
    console.log('Found cart items: ', getItems.length);
    const vegetablesSet = new Set();
    const herbsSet = new Set();
    const fruitsSet = new Set();

    getItems.forEach(item => {
      addItemsToSet(item, vegetablesSet, 'data-vegetables');
      addItemsToSet(item, herbsSet, 'data-spice');
      addItemsToSet(item, fruitsSet, 'data-fruits');
    });

    let nutrientTrackerText = 'Your health box contains:<br/>';

    if (fruitsSet.size > 0) {
      nutrientTrackerText += `<strong>${fruitsSet.size} type${fruitsSet.size > 1 ? 's' : ''} of fruit 🍎</strong><br/>`;
    }

    if (vegetablesSet.size > 0) {
      nutrientTrackerText += `<strong>${vegetablesSet.size} ${vegetablesSet.size > 1 ? 'varieties' : 'variety'} of vegetable 🥦</strong><br/>`;
    }

    if (herbsSet.size > 0) {
      nutrientTrackerText += `<strong>${herbsSet.size} ${herbsSet.size > 1 ? 'different' : ''} herbs, spices & grains 🫚</strong><br/>`;
    }
    nutrientTrackerText += `<a class='nutrient-tracker__learn-more' href="/blogs/news/unlock-the-power-of-plant-diversity-in-your-diet">Learn More →</a>`;

    const nutrientTrackerContentElement = document.querySelector(
      '.nutrient-tracker__body-contents'
    );
    nutrientTrackerContentElement.innerHTML = nutrientTrackerText;

    const total = fruitsSet.size + vegetablesSet.size + herbsSet.size;
    let totalColor = '#E8F8B0';
    if (total >= 25) {
      totalColor = '#36533E';
    } else if (total >= 15) {
      totalColor = '#45A780';
    } else if (total >= 6) {
      totalColor = '#8BCA6D';
    }

    const nutrientTrackerScoreElement = document.querySelector('.nutrient-tracker__score');
    nutrientTrackerScoreElement.style.backgroundColor = totalColor;
    const mobileNutrientTrackerScore = document.querySelectorAll('.cart-drawer__mobile-score');
    document.querySelector('.nutrient-tracker__score-top').textContent = total;
    mobileNutrientTrackerScore.forEach(element => {
      element.textContent = total;
    });

    const nutrientTrackerElement = document.querySelector('.nutrient-tracker');

    if (
      (vegetablesSet.size > 0 || fruitsSet.size > 0 || herbsSet.size > 0) &&
      window.innerWidth > 768
    ) {
      nutrientTrackerElement.classList.add('active');
      if (mobileNutrientTrackerElement) {
        mobileNutrientTrackerElement.style.display = '';
      }

      if (!isTimerActive) {
        isTimerActive = true;
        clearTimeout(timerId);
        timerId = setTimeout(() => {
          nutrientTrackerElement.classList.remove('active');
          if (mobileNutrientTrackerElement) {
            mobileNutrientTrackerElement.style.display = 'none';
          }
          isTimerActive = false;
        }, 12000);
      }
    } else {
      nutrientTrackerElement.classList.remove('active');
      if (mobileNutrientTrackerElement) {
        mobileNutrientTrackerElement.style.display = 'none';
      }
    }
  }

  function closeNutrientTracker() {
    const nutrientTrackerElement = document.querySelector('.nutrient-tracker');
    nutrientTrackerElement.classList.remove('active');
  }

  function handleClick(event) {
    var targetElement = event.target;
    while (targetElement != null) {
      if (targetElement.matches('.cart-drawer__mobile-nutrient-tracker')) {
        console.log('Mobile Nutrient Tracker Clicked');
        if (window.innerWidth <= 768) {
          const nutrientTrackerElement = document.querySelector('.nutrient-tracker');
          nutrientTrackerElement.classList.toggle('active');
          clearTimeout(timerId);
          timerId = setTimeout(() => {
            nutrientTrackerElement.classList.remove('active');
          }, 12000);
        }
        return;
      }
      targetElement = targetElement.parentElement;
    }
  }

  document.body.addEventListener('click', handleClick);

  document.addEventListener('cart:item-added', function () {
    setTimeout(updatenutrients, 700);
  });
  document.addEventListener('cart-drawer:open', function () {
    setTimeout(updatenutrients, 700);
  });
  document.addEventListener('line-item:change:end', function () {
    setTimeout(updatenutrients, 700);
  });
  document
    .querySelector('.nutrient-tracker__close-button')
    .addEventListener('click', closeNutrientTracker);
  document.addEventListener('itemAddedToCart', function () {
    setTimeout(updatenutrients, 1000);
  });
});
